const SvgBeakerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M7.5 5v3.751c0 .46 0 .689-.057.901-.05.189-.134.367-.247.527-.126.18-.303.327-.656.62l-3.08 2.568c-.353.294-.53.441-.656.621-.113.16-.196.338-.247.526-.057.213-.057.443-.057.902v.25c0 .934 0 1.4.182 1.757.16.314.414.569.728.729.357.181.823.181 1.757.181h9.666c.934 0 1.4 0 1.757-.181.314-.16.569-.415.728-.729.182-.356.182-.823.182-1.756v-.251c0-.46 0-.689-.057-.902a1.667 1.667 0 00-.247-.526c-.127-.18-.303-.327-.655-.62L13.459 10.8c-.352-.294-.528-.441-.655-.621a1.668 1.668 0 01-.247-.527c-.057-.212-.057-.442-.057-.9V5M6.917 5h6.166c.234 0 .35 0 .44-.045a.417.417 0 00.182-.182c.045-.09.045-.206.045-.44v-2c0-.233 0-.35-.045-.439a.417.417 0 00-.182-.182c-.09-.045-.206-.045-.44-.045H6.917c-.234 0-.35 0-.44.045a.417.417 0 00-.182.182c-.045.09-.045.206-.045.44v2c0 .233 0 .35.045.439.04.078.104.142.183.182.089.045.205.045.439.045zm-2.334 9.167h10.834c.387 0 .58 0 .742.032a1.667 1.667 0 011.309 1.31c.032.16.032.354.032.741s0 .58-.032.742a1.667 1.667 0 01-1.31 1.31c-.16.031-.354.031-.741.031H4.583c-.387 0-.58 0-.741-.032a1.667 1.667 0 01-1.31-1.31c-.032-.16-.032-.354-.032-.74 0-.388 0-.582.032-.743a1.667 1.667 0 011.31-1.31c.16-.031.354-.031.741-.031z"
    ></path>
  </svg>
)

export default SvgBeakerIcon
